export const LOGIN = `users/login`;
export const SIGNUP = `users`;
